<div class="container-fluid" style="padding: 20px 0 0 0; margin-bottom: 116px">
  <div *ngIf="totalSelectionArea > 0" class="alert"
       [ngClass]="{'alert-danger': totalSelectionArea < 50, 'alert-info': totalSelectionArea >= 50}" role="alert">
    <span>Gesamtgröße Auswahl: {{totalSelectionArea | number:'1.0-2':'de'}}km²</span><span
    *ngIf="totalSelectionArea < 50"> (Mindestgröße: 50km²)</span>
  </div>
  <ngb-alert type="danger" *ngIf="errorMsg">
    <strong>Fehler</strong> {{errorMsg}}
  </ngb-alert>

  <div ngbAccordion [closeOthers]="true">

    <div ngbAccordionItem *ngIf="selectedProduct !== 'LB'">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>Ein Gebiet in die Karte zeichnen</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <div class="col-sm-4">
                <button type="button" class="btn btn-outline-primary"
                        (click)="draw('rectangle')">Rechteck zeichnen
                </button>
              </div>
              <div class="col-sm-4">
                <button type="button" class="btn btn-outline-primary"
                        (click)="draw('polygon')">Polygon zeichnen
                </button>
              </div>
              <div class="col-sm-4">
                <button type="button" class="btn btn-outline-danger"
                        (click)="deleteGeom('drawLayer')" [disabled]="totalSelectionArea === 0">Geometrie löschen
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem *ngIf="selectedProduct !== 'LB'">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>Ein oder mehrere Gebiet/e auswählen</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">
              <img src="assets/icons/search.svg" alt="Suche">
            </span>
              </div>
              <input type="text" class="form-control" [(ngModel)]="searchText" (keyup)="searchBox(searchText)"
                     id="searchField">
            </div>
            <div class="tab-column" style="margin: 0">

              <ul ngbNav #areaNav="ngbNav" class="nav-tabs" (navChange)="onNavChange($event)">
                <li [ngbNavItem]="tabs.titleState">
                  <button ngbNavLink>{{tabs.titleState}}</button>
                  <ng-template ngbNavContent>
                    <div class="custom-tab-content">
                      <div class="form-check"
                           *ngFor="let itemBundesland of this.regionsService.getState() | filterList: searchText">
                        <input type="checkbox" class="form-check-input" id="{{ itemBundesland }}"
                               (change)="checkChange()"
                               [(ngModel)]="checkstateStates[itemBundesland]" [disabled]="(itemBundesland !== 'Nordrhein-Westfalen' && selectedProduct !== 'LB')">
                        <label class="form-check-label" for="{{ itemBundesland }}">
                          {{ itemBundesland }}
                        </label>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="tabs.titleDistrict">
                  <button ngbNavLink>{{tabs.titleDistrict}}</button>
                  <ng-template ngbNavContent>
                    <div class="custom-tab-content">
                      <div class="form-check"
                           *ngFor="let itemBezirke of this.regionsService.getDistrict() | filterList: searchText">
                        <input type="checkbox" class="form-check-input" id="{{ itemBezirke }}"
                               (change)="checkChange()"
                               [(ngModel)]="checkstateDistricts[itemBezirke]">
                        <label class="form-check-label" for="{{ itemBezirke }}">
                          {{ itemBezirke }}
                        </label>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="tabs.titleCounty">
                  <button ngbNavLink>{{tabs.titleCounty}}</button>
                  <ng-template ngbNavContent>
                    <div class="custom-tab-content">
                      <div class="form-check"
                           *ngFor="let itemKreise of this.regionsService.getCounty() | filterList: searchText">
                        <input type="checkbox" class="form-check-input" id="{{ itemKreise }}" (change)="checkChange()"
                               [(ngModel)]="checkstateCounties[itemKreise]">
                        <label class="form-check-label" for="{{ itemKreise }}">
                          {{ itemKreise }}
                        </label>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="tabs.titleKommunen">
                  <button ngbNavLink>{{tabs.titleKommunen}}</button>
                  <ng-template ngbNavContent>
                    <div class="custom-tab-content">
                      <div class="form-check"
                           *ngFor="let itemKommunen of this.regionsService.getKommunen() | filterList: searchText">
                        <input type="checkbox" class="form-check-input" id="{{ itemKommunen }}"
                               (change)="checkChange()"
                               [(ngModel)]="checkstateKommunen[itemKommunen]">
                        <label class="form-check-label" for="{{ itemKommunen }}">
                          {{ itemKommunen }}
                        </label>
                      </div>
                    </div>
                  </ng-template>
                </li>
              </ul>
              <div [ngbNavOutlet]="areaNav"></div>

            </div>
            <div class="row" *ngIf="this.regionsService.getSelectedRegions().length > 0" style="margin-top: 20px">
              <div class="col-xl-12">
                Ausgewählte Regionen
                <ul>
                  <li *ngFor="let selectedRegion of this.regionsService.getSelectedRegions()">{{ selectedRegion }}</li>
                </ul>
                <hr/>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem *ngIf="selectedProduct === 'LB'" [collapsed]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>Bundesland auswählen</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="form-check"
                 *ngFor="let itemBundesland of this.regionsService.getState() | filterList: searchText">
              <input type="radio" class="form-check-input" name="radioBundesland" id="{{ itemBundesland }}"
                     (change)="setSelectedState(itemBundesland)" [checked]="checkstateStates[itemBundesland]">
              <label class="form-check-label" for="{{ itemBundesland }}">
                {{ itemBundesland }}
              </label>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem="static-3" *ngIf="selectedProduct !== 'LB'">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>Eigene .shp oder .zip Datei hochladen</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="input-group mb-3" [ngClass]="{'no-margin-bottom': fileType !== 'shp' && !fileToUpload}">
              <div class="custom-file">

                <label for="formFile" class="form-label">Wählen Sie eine .shp-Datei aus (optional innerhalb eines zip-Archivs).</label>
                <input class="form-control" type="file" id="formFile" accept="application/zip,.shp" (change)="checkFile($event)">

              </div>
            </div>
            <div *ngIf="fileType === 'shp'" class="input-group mb-3" [ngClass]="{'no-margin-bottom': !selectedEPSG}">
              <select class="custom-select" id="inputGroupSelect01" (change)="selectEPSG($event)">
                <option disabled>Bitte wählen Sie eine Projektion</option>
                <option value="EPSG:3857">WGS 84 / Pseudo-Mercator &#45;&#45; Spherical Mercator (EPSG:3857)</option>
                <option value="EPSG:4326">WGS 84 &#45;&#45; WGS84 - World Geodetic System 1984 (EPSG:4326)</option>
                <option value="EPSG:25832">ETRS89 / UTM zone 32N (EPSG:25832)</option>
                <option value="EPSG:31466">DHDN / 3-degree Gauss-Kruger zone 2 (EPSG:31466)</option>
                <option value="EPSG:31467">DHDN / 3-degree Gauss-Kruger zone 3 (EPSG:31467)</option>
              </select>
            </div>
            <div *ngIf="fileToUpload && (selectedEPSG || fileType === 'zip')" class="flex-row align-items-center justify-content-start">
              <button type="button" class="btn btn-outline-primary" (click)="uploadFile()">Hochladen
              </button>&nbsp;
              <button *ngIf="totalSelectionArea" type="button" class="btn btn-outline-danger" (click)="deleteGeom('drawLayer')">
                Geometrie löschen
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

  </div>
</div>

<ng-template #help let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Hinweis zur Gebietsauswahl</h4>
    <button class="btn btn-outline-secondary" type="button" title="Schließen" aria-label="Close" (click)="modal.dismiss('cross click')">
      <img src="assets/icons/close.svg" alt="Schließen" width="16" height="16" style="margin-bottom: 4px">
    </button>
  </div>
  <div class="modal-body">
    <p>
      Bitte beachten Sie, dass die Ergebnisse aller in der Gebietsauswahl ausgewählten Gebiete/Geometrien, die Teil
      eines Auftrags sind, in einer einzigen Shape-Datei ausgeliefert werden.
    </p>
    <p>
      Falls Sie für jedes gewählte Gebiet eine Shape-Dateien benötigen müssen Sie dafür jeweils einen eigenen Auftrag
      erstellen!
    </p>
    <input type="checkbox" class="form-check-input" id="checkbox-hide-areaselection-help"
           (change)="toggleAreaSelectionHelp()" [(ngModel)]="hideHelp">
    <label class="form-check-label" for="checkbox-hide-areaselection-help">
      Diesen Hinweis nicht mehr anzeigen
    </label>
  </div>
</ng-template>

<ng-template #areaTooSmall let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Gewähltes Gebiet zu klein</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Für das automatische Training muss ein Gebiet von mindestens 50km² gewählt werden.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="modal.dismiss('Cross click')">Weiter
    </button>
  </div>
</ng-template>
